import i18n from '../i18n';

// Mirrors public-pages/locales/config.json. Must stay in sync if a new locale is added there.
const SUPPORTED_LOCALES = ['en', 'es'];
const DEFAULT_LOCALE = 'en';

// Prefixes a marketing path with the active locale. Callers pass the marketing slug directly
// (e.g. '/privacy', '/partners') — this helper does not translate SPA slugs, so pass the public
// page's actual path as it lives in public-pages/.
const marketingUrl = (path = '/') => {
  const detected = (i18n.language || '').slice(0, 2).toLowerCase();
  const locale = SUPPORTED_LOCALES.includes(detected) ? detected : DEFAULT_LOCALE;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `/${locale}${normalized}`;
};

export default marketingUrl;
